<template>
  <div class="soutien-wrap pt-20 pb-20">
    <div class="container mx-auto px-4">
      <!-- Titre principal -->
      <h2 class="text-3xl font-bold text-center mb-8 text-gray-800 uppercase">
        Soutiens
      </h2>

      <!-- Contenu principal -->
      <div class="prose max-w-4xl mx-auto text-justify leading-relaxed text-gray-800">
        <p class="text-lg mb-6">
          Un autre <strong>pôle d’engagement</strong> consiste à
          <strong>Soutenir l’œuvre EITP</strong> :
        </p>

        <ul class="list-disc list-inside mb-6 text-gray-700">
          <li class="mb-2">
            En participant aux fonds EITP pour la formation et la construction ;
          </li>
          <li>
            En suscitant des bonnes volontés pour soutenir financièrement l’œuvre
            ou promouvoir des activités culturelles religieuses.
          </li>
        </ul>

        <p class="mt-6 italic text-center text-gray-600 text-lg">
          « Contribuer à la mission, c’est aussi semer dans le champ de Dieu. »
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SoutiensComp",
});
</script>

<style scoped>
.soutien-wrap {
  background-color: #fdfdfd;
}

.prose p {
  margin-bottom: 1rem;
}

ul li {
  margin-bottom: 0.5rem;
}
</style>
